export default {
  metaTitle: 'Product Recommendations',
  pageTitle: 'Product Recommendations',
  recommendedList: 'Recommended list',
  placeholder1: `Please fill in the product's listing ID. If recommending multiple products, you can achieve batch input by inserting a comma between different listing IDs. For example: 10003993, 1000482, 10007644`,
  save: 'Save',
  content1: 'The product ID is Error,Please fill in the correct one',
  error1: 'Please use English commas.',
  error2: 'The product ID cannot exceed 16, the ID must be an integer, and the beginning and end cannot be commas or spaces.',
  columnListing1: 'Listing Id',
  columnListing2: 'Title',
  columnListing3: 'Price Min',
  columnListing4: 'Price Max',
  columnListing5: 'Sku Count',
  columnListing6: 'Status',
  columnListing7: 'Weight',
  columnListing8: 'Operation',
  status1: 'Offline',
  status2: 'Online',
  remove: 'Remove'
}
